import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner automotive-back">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">EDUCATION</h2>
						<div className="red-border"> </div>
						<p>Think beyond traditional learning and drive innovation with our educational solutions tailored to enhance workforce performance.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
